import { createContext } from "react";
import type { AppContextType } from "../../@types/context";

export const AppContext = createContext({} as AppContextType);

export const AppStore = {
  AppContext,
};
